import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { CustomBreakpoints } from '../../../../../../themes/default';

export const useStyles = makeStyles(({
  breakpoints,
  spacing,
  palette,
  borderRadiuses,
}: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem',
    border: `1px solid ${palette.grey['400']}`,
    borderRadius: borderRadiuses.md,
  },
  lensesBrandLogo: {
    width: 'auto',
    height: 68,
  },
  lensesBrandLogoAOM1D: {
    height: 88,
  },
  eyeParamsContainer: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    gap: spacing(1.5),
  },
  block: {
    display: 'block',
  },
  messageStyles: {
    maxWidth: 200,
    [breakpoints.between('xl', CustomBreakpoints.outOfSalesDesktopNarrow)]: {
      maxWidth: 120,
    },
  },
}));
